import fetch from 'api/fetch'
// 初始化获取购物车列表信息
export function getCommodityApi() {
  return fetch({
    showErrorPage: true,
    url: '/v2/shopcart/query/list',
    checkFromWxMini: true,
    method: 'GET'
  })
}
// 购物车推荐商品
export function getRecommendApi() {
  return fetch({
    url: '/v2/shopcart/recommendCommodity',
    method: 'POST'
  })
}
// 异步拉取列表页所有SPU缺货和下架商品的推荐商品信息
export function getInvalidRecommendInfoApi(){
  return fetch({
    url: '/v2/shopcart/query/invalidCommodityRecommendInfo',
    method: 'GET'
  })
}
// 购物车选中/取消选中
export function changeCheckStatusApi(params) {
  return fetch({
    url: '/v2/shopcart/changeCheckStatus',
    checkFromWxMini: true,
    method: 'POST',
    setCsrfToken: true,
    data: params
  })
}

// 购物车全选/取消全选
export function changeAllCheckStatusApi(params) {
  return fetch({
    url: '/v2/shopcart/changeAllStatus',
    checkFromWxMini: true,
    method: 'POST',
    setCsrfToken: true,
    data: params
  })
}

// 购物车修改规格/服务/加价购/数量，修改赠品
export function modifyCommodityApi(params) {
  return fetch({
    url: '/v2/shopcart/modifyCommodity',
    checkFromWxMini: true,
    method: 'POST',
    setCsrfToken: true,
    data: params
  })
}

// 删除商品
export function removeProductApi(params) {
  return fetch({
    url: '/v2/shopcart/deleteCommodity',
    checkFromWxMini: true,
    method: 'POST',
    setCsrfToken: true,
    data: params
  })
}

// 批量移入收藏夹
export function moveToFavoriteApi(params) {
  return fetch({
    url: '/v2/shopcart/addToFavorite',
    checkFromWxMini: true,
    method: 'POST',
    setCsrfToken: true,
    data: params
  })
}

// 提交结算
// export function settleCommodityApi(calcList) {
//   return fetch({
//     url: '/shopCart/settleCommodity',
//     method: 'POST',
//     data: calcList
//   })
// }
export function settleCommodityApi(params) {
  return fetch({
    url: '/v2/shopcart/try',
    checkFromWxMini: true,
    method: 'POST',
    data: params
  })
}

// 加入购物车
export function addCommodityApi(params) {
  return fetch({
    url: '/v2/shopcart/addCommodity',
    checkFromWxMini: true,
    method: 'POST',
    setCsrfToken: true,
    data: params
  })
}
// 自动领券接口couponUuids, longitude, latitude
export function autoReceiveCouponReq(params) {
  return fetch({
    url: '/coupon/autodirect',
    params
  })
}